import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twothree-twofour',
  templateUrl: './twothree-twofour.component.html',
  styleUrls: ['./twothree-twofour.component.scss']
})
export class TwothreeTwofourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
